import LegalLayout from '../LegalLayout';

export default function Consent() {
  return (
    <LegalLayout
      title="Согласие на обработку персональных данных"
      updatedAt="24 апреля 2026 года"
    >
      <p>
        Совершая регистрацию на&nbsp;сайте <strong>resstro.ru</strong> или используя
        электронное меню заведения, я&nbsp;даю своё согласие следующему оператору
        персональных данных:
      </p>
      <ul>
        <li>Индивидуальный предприниматель Раджабов Рустам Эфлетдинович;</li>
        <li>ИНН&nbsp;051707862851;</li>
        <li>Email: <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a>;</li>
        <li>далее «Оператор».</li>
      </ul>

      <h2>1. Цели обработки</h2>
      <ul>
        <li>регистрация и&nbsp;идентификация пользователя в&nbsp;Сервисе Resstro&nbsp;SaaS;</li>
        <li>предоставление доступа к&nbsp;административной панели, кассовому приложению и&nbsp;электронному меню;</li>
        <li>приём платежей и&nbsp;формирование фискальных документов;</li>
        <li>направление сервисных уведомлений, связанных с&nbsp;работой Сервиса;</li>
        <li>исполнение требований законодательства Российской Федерации.</li>
      </ul>

      <h2>2. Перечень обрабатываемых данных</h2>
      <ul>
        <li>фамилия, имя, отчество (при наличии);</li>
        <li>адрес электронной почты и&nbsp;номер телефона;</li>
        <li>реквизиты заведения: наименование, адрес, ИНН;</li>
        <li>идентификатор платёжного метода ЮKassa;</li>
        <li>сведения о&nbsp;заказах, чеках и&nbsp;оплатах;</li>
        <li>технические данные устройства и&nbsp;браузера, IP-адрес.</li>
      </ul>

      <h2>3. Действия с&nbsp;данными</h2>
      <p>
        Оператор осуществляет с&nbsp;персональными данными следующие действия:
        сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение,
        использование, передачу обработчикам, перечисленным в&nbsp;
        <a href="/legal/privacy">Политике конфиденциальности</a>, обезличивание,
        блокирование, удаление, уничтожение как автоматизированным,
        так и&nbsp;ручным способом.
      </p>

      <h2>4. Срок действия согласия</h2>
      <p>
        Настоящее согласие действует с&nbsp;момента его предоставления и&nbsp;до&nbsp;достижения
        целей обработки либо до&nbsp;момента его отзыва пользователем.
        Пользователь вправе отозвать согласие, направив письменное уведомление
        на&nbsp;<a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a>.
        В&nbsp;течение 30&nbsp;календарных дней учётная запись блокируется,
        а&nbsp;данные удаляются за&nbsp;исключением сведений, которые Оператор
        обязан хранить по&nbsp;закону.
      </p>

      <h2>5. Согласие на&nbsp;информационные рассылки</h2>
      <p>
        Согласие на&nbsp;получение информационных и&nbsp;маркетинговых рассылок
        запрашивается отдельно при регистрации. Отказ от&nbsp;маркетинговых писем
        не&nbsp;влияет на&nbsp;возможность пользоваться Сервисом и&nbsp;не&nbsp;останавливает
        получение сервисных уведомлений (биллинг, безопасность, технические работы).
      </p>

      <h2>6. Ответственность</h2>
      <p>
        Оператор обязуется соблюдать режим конфиденциальности и&nbsp;применять технические
        и&nbsp;организационные меры защиты данных в&nbsp;соответствии с&nbsp;требованиями
        152-ФЗ и&nbsp;принимаемых на&nbsp;его основании подзаконных актов.
      </p>

      <h2>7. Контакты</h2>
      <p>
        Вопросы, связанные с&nbsp;обработкой персональных данных, направляйте на&nbsp;
        <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a> или в&nbsp;
        <a href="https://wa.me/79894734322" target="_blank" rel="noopener noreferrer">
          WhatsApp +7&nbsp;989&nbsp;473-43-22
        </a>
        .
      </p>
    </LegalLayout>
  );
}
